import React from "react";

export default function Welcome() {
  return (
    <div className="container">
      <h1>¿Qué es CB 3.0?</h1>
      <p>
        El espacio de la WebApp de IBRAHIM C.B tiene como Objetivo Principal
        disponer de un espacio que nos permita recopilar información con fines
        de estudiar diferentes fenómenos donde Investigadores especialistas
        correlacionarán los resultados a información estadística, para
        identificar la correspondencia entre las percepciones expresadas y los
        comportamientos en diferentes situaciones de consumo, uso y
        preferencias. No dudes en ser parte de los Estudio de{" "}
        <strong>IBRAHIM C.B</strong>, se informa que en esta etapa no se efectúa
        pago por la participación en los estudios para ayúdanos contestando la
        presente encuesta. Mayor información{" "}
        <a href="mailto:info@ibrahim.com.co">info@ibrahim.com.co</a>
      </p>
      <p>
        En <strong>IBRAHIM C.B</strong>, valoramos la privacidad y la
        transparencia, por lo que es importante conozca nuestra Política de
        privacidad y los Términos de uso, que están vigentes desde el 15 de mayo
        de 2018. Nuestros usuarios contaran con un espacio de información legal
        para que sea fácil encontrar sobre:
      </p>
      <ol>
        <li>
          Privacidad al participar en los estudios a través de la plataforma{" "}
          <strong>CB 3.0</strong>.
        </li>
        <li>
          Manejo de la información de acuerdo con la Ley 1581 de 2012 y su
          decreto Reglamentario 1377 de 2013, o Ley de protección de Datos
          Personales
        </li>
        <li>
          Política de seguridad e incluimos las condiciones relacionadas con
          procesamiento de datos que explican cómo los clientes pueden auditar
          nuestra seguridad.
        </li>
        <li>
          Informamos sobre cómo ejercer derechos sobre los datos y cómo
          controlar el uso de su información personal a través de nuestros
          servicios.
        </li>
        <li>
          También explicamos cómo podemos ayudarte con las solicitudes de datos
          que quizás recibas de los encuestados
        </li>
        <li>
          Por política informamos que NO hemos incluido tecnología de
          aprendizaje automático orientada ni a venta, ni a uso de cookies y
          otras tecnologías para el seguimiento para personalizar información
          que reciba de nosotros.
        </li>
        <li>
          Se informa cómo se usan los datos de los encuestados agregados para
          identificar tendencias y mejorar nuestros informes sin suministrar
          datos personales de los participantes en nuestros informes para
          empresas.
        </li>
        <li>
          Informamos que la información que se obtiene a través del aplicativo{" "}
          <strong>CB 3.0</strong> es comercializada a terceros sin hacer venta
          de bases de datos o información personal.
        </li>
      </ol>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Content/Welcome.js